import React from 'react';
import { motion } from 'framer-motion';
import { XCircle } from 'lucide-react';
export function Problems() {
  const problems = [{
    num: '01',
    text: 'Llegás a la sesión sin saber exactamente qué herramienta usar con esta paciente hoy'
  }, {
    num: '02',
    text: 'Tus pacientes no progresan porque no tenés una secuencia clara de intervención'
  }, {
    num: '03',
    text: 'El 40% de tus pacientes abandona el acompañamiento antes de los 3 meses y no sabés cómo prevenirlo'
  }, {
    num: '04',
    text: 'Siempre los mismos recursos de siempre porque no tenés más material clínico listo'
  }, {
    num: '05',
    text: 'No podés justificar un aumento de honorarios porque no tenés un sistema profesional visible'
  }, {
    num: '06',
    text: 'Intervenciones improvisadas sin un método claro que te respalde'
  }, {
    num: '07',
    text: 'Pacientes con perfiles muy distintos y la sesión grupal se convierte en un caos'
  }, {
    num: '08',
    text: 'Fin de mes y las pacientes se van sin avisar porque la comunicación es inconsistente'
  }];
  return <section className="py-12 md:py-24 bg-white px-4 sm:px-6 lg:px-8" data-id="element-233">
      <div className="max-w-5xl mx-auto" data-id="element-234">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-8 md:mb-16" data-id="element-235">
          <h2 className="text-2xl md:text-4xl font-bold text-navy mb-4" data-id="element-236">
            Si sos profesional de postparto en Argentina, esto te va a sonar
            familiar:
          </h2>
        </motion.div>

        <div className="grid md:grid-cols-2 gap-x-12 gap-y-4 md:gap-y-8 mb-10 md:mb-20" data-id="element-237">
          {problems.map((prob, i) => <motion.div key={i} initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.4,
          delay: i * 0.1
        }} className="flex gap-3 md:gap-4 items-start bg-cream/30 md:bg-transparent p-3 md:p-0 rounded-xl md:rounded-none" data-id="element-238">
              <div className="flex-shrink-0 mt-0.5 md:mt-1" data-id="element-239">
                <XCircle className="w-5 h-5 md:w-6 md:h-6 text-terracotta/80" data-id="element-240" />
              </div>
              <div data-id="element-241">
                <span className="text-terracotta font-serif font-bold text-base md:text-lg mr-2" data-id="element-242">
                  {prob.num}
                </span>
                <span className="text-navy/80 text-sm md:text-base leading-relaxed" data-id="element-243">
                  {prob.text}
                </span>
              </div>
            </motion.div>)}
        </div>

        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} className="text-center" data-id="element-244">
          <h3 className="text-2xl md:text-5xl font-serif font-bold text-terracotta italic" data-id="element-245">
            ¿Cuántas sesiones más vas a improvisar?
          </h3>
        </motion.div>
      </div>
    </section>;
}